


  const qrCodes = [
    {code:"SD6FG0",pn:5},
    {code:"PZ6FG4",pn:13},
    {code:"AC6FG8",pn:9},
    {code:"GR6FG0",pn:12},
    {code:"YH6FG5",pn:10},
    {code:"SE6FG0",pn:11},
    {code:"SH6FG3",pn:8},
    {code:"SP6OG6",pn:1},
    {code:"CD6YG0",pn:7},
    {code:"T06FG0",pn:14},
    {code:"FL6FG9",pn:4},
    {code:"SD6AG2",pn:3},
    {code:"S86FG0",pn:6},
    {code:"Y76FG7",pn:15},
    {code:"FD6FG1",pn:2},
  ]
  // | Bıttım | Wild Pistachio |
  // | Eşek Sütlü | Donkey Milk |
  // | Keçi Sütlü | Goat Milk |
  // | Lavanta | Lavender |
  // | Zeytin Yağlı Defne | Olive Oil With Laurel |
  // | Kantaron Yağlı | Centaury Oil |
  // | Çamardıç Kükürt | Turmeric Sulfur |
  // | Termal Kil | Thermal Clay |
  // | Saf Zeytin Yağlı | Pure Olive Oil |
  // | Kükürt | Sulfur |

  //
  //
  //

  const images = {
    detail:{
      centaury_oil_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/centaury_oil_flat.png",
      donkey_milk_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/donkey_milk_flat.png",
      goat_milk_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/goat_milk_flat.png",
      lavender_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/lavender_flat.png",
      olive_oil_with_laurel_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/olive_oil_with_laurel_flat.png",
      pure_olive_oil_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/pure_olive_oil_flat.png",
      sulfur_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/sulfur_flat.png",
      thermal_clay_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/thermal_clay_flat.png",
      turmeric_sulfur_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/turmeric_sulfur_flat.png",
      wild_pistachio_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/wild_pistachio_flat.png",
    }
}

  const productDetailTr={
    title:`%100 Doğal El Yapımı Sabun Seti`,
    description:`Genel olarak saç ve cild üzerinde etkilidir. Cilt üzerindeki etkilerini egzama ve mantar gibi ciltte oluşan daha ciddi problemlerle de gösteriyor, bu sorunların iyileşme sürecine destek oluyor.  Mis kokulu ve çok iyi köpüren tamamen doğal el yapımı olan birbirinden farklı 10 paket sabun seti, sağlığınızı korumak için yanınızda.`,
    description1:`Düzenli olarak sabah, öğle ve akşam olmak üzere günde 3 defa uygulayın. Cildinizi köpürttükten sonra 5 dakika bekleyin. Ardından bol su ile durulayın`,
    images:{
        cover:"https://pistatic.piyanos.com/uploads/link/qr/shop/IMG_3950-removebg-preview.png",
        list:[
            "https://pistatic.piyanos.com/uploads/link/qr/shop/IMG_3950-removebg-preview.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/pure_olive_oil_cross.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/turmeric_sulfur_cross.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/one_packeded.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/IMG_3928-removebg-preview.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/bath_fiber.png",
    ],
        detail:{
            centaury_oil_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/centaury_oil_flat.png",
            donkey_milk_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/donkey_milk_flat.png",
            goat_milk_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/goat_milk_flat.png",
            lavender_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/lavender_flat.png",
            olive_oil_with_laurel_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/olive_oil_with_laurel_flat.png",
            pure_olive_oil_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/pure_olive_oil_flat.png",
            sulfur_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/sulfur_flat.png",
            thermal_clay_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/thermal_clay_flat.png",
            turmeric_sulfur_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/turmeric_sulfur_flat.png",
            wild_pistachio_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/wild_pistachio_flat.png",
        },
    },
    soaps:[
      {
        title:"Bıttım",
        images:{
          cover:images.detail.wild_pistachio_flat
        },
        items:[
          "- Saç dökülmesini ve beyazlamasını önler",
          "- Kepek oluşumunu engeller. Antiseptik özellik taşır",
          "- Sivilce ve aknelerin yok edilmesinde etkilidir",
          "- Cilde peeling etkisi yapar",
          "- Cildi yumuşatır ve cildeki lekeleri yok eder"
        ]
      },
      {
        title:"Eşek Sütlü",
        images:{
          cover:images.detail.donkey_milk_flat
        },
        items:[
          "- Cildin nem oranını dengeler",
          "- Cilde parlaklık verir",
          "- Cilt kararmaları ve cilt lekelerini önler",
          "- Siyah nokta, akne ve sivilce oluşumunu engeller",
          "- Ciltteki ölü derileri temizler",
          "- Saç köklerini güçlendirir",
        ]
      },
      {
        title:"Keçi Sütlü",
        images:{
          cover:images.detail.goat_milk_flat
        },
        items:[
          "- Cildi nemlendirir",
          "- Gözenekleri sıkılaştırır",
          "- Sivilcelerin oluşmasını engeller",
          "- Siyah noktaların oluşmasını engeller",
          "- Saç derisinin ve saç tellerinin nemlenmesini sağlıyor"
        ]
      },
      {
        title:"Lavanta",
        images:{
          cover:images.detail.lavender_flat
        },
        items:[
          "- Cildin yağlanmasını önler",
          "- Cilde parlaklık ve canlılık kazandırır",
          "- Cildin sıkılaşmasında ciddi etkisi vardı",
          "- Cilt lekelerinin azalmasını sağlar",
          "- Cilt yüzeyinde meydana gelen kızarıklık, yara ve tahrişlerde tedavi edici özelliği bulunur",
          "- Saçın doğal bir canlılık ve parlaklığa kavuşmasını sağlar",
        ]
      },
      {
        title:"Zeytin Yağlı Defne",
        images:{
          cover:images.detail.olive_oil_with_laurel_flat
        },
        items:[
          "- Egzamayı İyileştirir",
          "- Ayak Mantarını Temizler",
          "- Sivilceyi Kurutur",
          "- Tahrişi Önler",
          "- Kaşıntıyı Giderir",
          "- Saç Derisini Besler",
          "- Cildi Nemlendirir",
          "- Ciltteki Enfeksiyonu Temizler"
        ]
      },
      {
        title:"Kantaron Yağlı",
        images:{
          cover:images.detail.centaury_oil_flat
        },
        items:[
          "- Varis ve damarsal sorunların çözümünü sağlar",
          "- Hücre yenilenmesini sağlayarak yaşlanma belirtilerini geciktirir",
          "- Cildin olması gereken nem dengesine ulaşmasını sağlar",
          "- Cilt tonunun eşitlenmesi sağlar",
          "- Sivilce oluşumunu ve izlerin azalmasına katkı sağlar",
          "- Ciltteki yara, yanık ve sivilcelerin iyileşmesine katkı sağlar"
        ]
      },
      {
        title:"Çamardıç Kükürt",
        images:{
          cover:images.detail.turmeric_sulfur_flat
        },
        items:[
          "- Sivilce, kaşıntı ve ciltteki mikropları temizler",
          "- Mantar hastalığına karşı ortamı dezenfekte eder",
          "- Ciltte ve saç derisinde oluşan pullanmayı giderir",
          "- Cilt sorunlarının giderilmesine yardımcı olur",
          "- Saç dökülmesini önlemeye yardımcı olur"
        ]
      },
      {
        title:"Termal Kil",
        images:{
          cover:images.detail.thermal_clay_flat
        },
        items:[
          "- Sıvı emme özelliği ile cildi temizler",
          "- Cilt ve yüz bölgesini detoksifiye eder",
          "- Cildi ve yüz bölgesini toksinlerden arındırır",
          "- Doğal peeling özelliği bulunmaktadır. Bu sayede cildi ölü hücrelerden arındırmaktadır",
          "- Ciltlerdeki iltihapları temizler, akne ve sivilceleri yok eder",
          "- Ciltteki koy lekeleri yok eder ve cilt tonunu eşitler"
        ]
      },
      {
        title:"Saf Zeytin Yağlı",
        images:{
          cover:images.detail.pure_olive_oil_flat
        },
        items:[
          "- Cildi nemlendirir ve parlatır",
          "- Yaşlanmayı geciktirir. Kırışık oluşumunu önler",
          "- Sivilce ve gözenek oluşumunu engeller",
          "- Cilt problemlerinde iyileşmeye yardımcı olur",
          "- Kepeği ve saç dökülmesini önler",
          "- Saçların hızlı uzamasını sağlar"
        ]
      },
      {
        title:"Kükürt",
        images:{
          cover:images.detail.sulfur_flat
        },
        items:[
          "- Mantar ve benzeri enfeksiyonların ortadan kaldırılmasında etkilidir",
          "- Gül hastalığına iyi gelir",
          "- Egzamaya iyi gelir",
          "- Cildi yeniler ve sıkılaştırır",
          "- Terleme sorunlarını önler",
          "- Uyuza karşı etkilidir",
          "- Yağlı saçları arındırır, canlandırır",
          "- Sivilce ve akne tedavisinde Kullanılır"
        ]
      },
    ]
  }
  const productDetailEn={
    title:`100% Natural Handmade Turkish Soap Set`,
    description:`It is effective on hair and skin in general. It shows its effects on the skin with more serious skin problems such as eczema and fungus, and supports the healing process of these problems. 10 packs of soap sets, which are completely natural and handmade, which are fragrant and foam very well, are with you to protect your health.`,
    description1:`Apply regularly 3 times a day in the morning, afternoon and evening. Wait 5 minutes after lathering your skin. Then rinse with plenty of water`,
    images:{
        cover:"https://pistatic.piyanos.com/uploads/link/qr/shop/IMG_3950-removebg-preview.png",
        list:[
            "https://pistatic.piyanos.com/uploads/link/qr/shop/IMG_3950-removebg-preview.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/pure_olive_oil_cross.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/one_packeded.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/IMG_3928-removebg-preview.png",
            "https://pistatic.piyanos.com/uploads/link/qr/shop/bath_fiber.png",
    ],
        detail:{
            centaury_oil_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/centaury_oil_flat.png",
            donkey_milk_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/donkey_milk_flat.png",
            goat_milk_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/goat_milk_flat.png",
            lavender_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/lavender_flat.png",
            olive_oil_with_laurel_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/olive_oil_with_laurel_flat.png",
            pure_olive_oil_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/pure_olive_oil_flat.png",
            sulfur_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/sulfur_flat.png",
            thermal_clay_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/thermal_clay_flat.png",
            turmeric_sulfur_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/turmeric_sulfur_flat.png",
            wild_pistachio_flat:"https://pistatic.piyanos.com/uploads/link/qr/shop/flat/wild_pistachio_flat.png",
        },
    },
    soaps:[
      {
        title:"Wild Pistachio",
        images:{
          cover:images.detail.wild_pistachio_flat
        },
        items:[
          "- Prevents hair loss and graying",
          "- It prevents the formation of dandruff. Has antiseptic properties",
          "- Effective in eliminating acne and acne",
          "- Exfoliates the skin",
          "- Softens the skin and removes blemishes on the skin"
        ]
      },
      {
        title:"Donkey Milk",
        images:{
          cover:images.detail.donkey_milk_flat
        },
        items:[
          "- Balances the moisture content of the skin",
          "- Gives shine to the skin",
          "- Prevents skin darkening and skin spots",
          "- Prevents the formation of blackheads, acne and pimples",
          "- Cleanses the dead skin on the skin",
          "- Strengthens hair roots",
        ]
      },
      {
        title:"Goat Milk",
        images:{
          cover:images.detail.goat_milk_flat
        },
        items:[
          "- Moisturizes the skin",
          "- Tightens pores",
          "- Prevents the formation of acne",
          "- Prevents the formation of blackheads",
          "- Moisturizes the scalp and hair strands"
        ]
      },
      {
        title:"Lavender",
        images:{
          cover:images.detail.lavender_flat
        },
        items:[
          "- Prevents the skin from getting oily",
          "- Brings shine and vitality to the skin",
          "- It had a serious effect on skin tightening",
          "- Provides reduction of skin blemishes",
          "- It has therapeutic properties in redness, wounds and irritations on the skin surface",
          "- Provides the hair with a natural vitality and shine"
        ]
      },
      {
        title:"Olive Oil With Laurel",
        images:{
          cover:images.detail.olive_oil_with_laurel_flat
        },
        items:[
          "- Cures Eczema",
          "- Clears Foot Fungus",
          "- Dries Pimples",
          "- Prevents Irritation",
          "- Relieves Itch",
          "- Nourishes Scalp",
          "- Moisturizes the Skin",
          "- Clears Infection In The Skin"
        ]
      },
      {
        title:"Centaury Oil",
        images:{
          cover:images.detail.centaury_oil_flat
        },
        items:[
          "- Provides the solution of varicose and vascular problems",
          "- It delays the signs of aging by providing cell regeneration",
          "- Allows the skin to reach the moisture balance it should be",
          "- Provides equalization of skin tone",
          "- Contributes to the formation of acne and the reduction of scars",
          "- Contributes to the healing of wounds, burns and acne on the skin"
        ]
      },
      {
        title:"Turmeric Sulfur",
        images:{
          cover:images.detail.turmeric_sulfur_flat
        },
        items:[
          "- Cleanses acne, itching and germs on the skin",
          "- Disinfects the environment against fungal disease",
          "- Removes flaking on the skin and scalp",
          "- Helps to eliminate skin problems",
          "- Helps prevent hair loss"
        ]
      },
      {
        title:"Thermal Clay",
        images:{
          cover:images.detail.thermal_clay_flat
        },
        items:[
          "- Cleanses the skin with its liquid absorption feature",
          "- Detoxifies the skin and face area",
          "- Cleanses the skin and facial area from toxins",
          "- It has a natural peeling feature. In this way, it purifies the skin from dead cells",
          "- Cleanses the inflammations on the skin, eliminates acne and pimples",
          "- It removes dark spots on the skin and evens out the skin tone"
        ]
      },
      {
        title:"Pure Olive Oil",
        images:{
          cover:images.detail.pure_olive_oil_flat
        },
        items:[
          "- Moisturizes and brightens the skin",
          "- Delays aging. Prevents wrinkle formation",
          "- Prevents the formation of acne and pores",
          "- Helps heal skin problems",
          "- Prevents dandruff and hair loss",
          "- It makes hair grow faster"
        ]
      },
      {
        title:"Sulfur",
        images:{
          cover:images.detail.sulfur_flat
        },
        items:[
          "- It is effective in eliminating fungal and similar infections",
          "- It is good for rose disease",
          "- It is good for eczema",
          "- Renews and tightens the skin",
          "- Prevents sweating problems",
          "- It is effective against scabies",
          "- Purifies, revitalizes oily hair",
          "- Used in the treatment of acne and acne"
        ]
      },
    ]
  }

  const productDetail = {
    en:productDetailEn,
    tr:productDetailTr
  }

  module.exports={
    productDetail,
    qrCodes
  }